import Backbone from 'backbone';

import {PolymerFeatureAttributes} from 'constants/SequenceConstants';

interface SequenceRegionServerResponse extends PolymerFeatureAttributes {
  start_offset?: number;
  start_part_id?: number;
  end_offset?: number;
  end_part_id?: number;
}

class SequenceRegion extends Backbone.Model {
  fromSubPart(): boolean {
    return this.get('fromSubPart');
  }
  editable(): boolean {
    return !this.fromSubPart();
  }

  defaults(): Partial<PolymerFeatureAttributes> {
    return {
      start: 0,
      end: 0,
      fromSubPart: false,
    };
  }

  start(): number {
    return this.get('start');
  }
  end(): number {
    return this.get('end');
  }

  clone(offset: number = 0): this {
    const copy = super.clone() as SequenceRegion;
    return copy.set({
      start: this.start() + offset,
      end: this.end() + offset,
    }) as this;
  }

  parse(response: SequenceRegionServerResponse): PolymerFeatureAttributes {
    // The client doesn't care about these values.
    // And should NOT report them back to the server
    // since it will be sending start/end.

    delete response.start_offset;
    delete response.end_offset;
    delete response.start_part_id;
    delete response.end_part_id;
    return response;
  }

  // Defines editing behavior
  allowFullReplace(): boolean {
    return false;
  }
}

export default SequenceRegion;
